import {
  CancelReasonType,
  CareSubscriptionPaymentStatus,
  EnrollmentStatus,
  ManageMembershipRequestType,
  PaymentSchedule,
} from 'shared/types/graphql';

export interface IClinicInfo {
  clinicName: string;
  clinicId: string;
}

export interface IUserInfo {
  name: string;
  email: string;
  id: string;
}
export interface IClientInfo {
  clientName: string;
  clientId: string;
}

export interface IStripeCustomerInfo {
  stripeCustomerId: string;
}

export interface ITrueUpInfo {
  trueUpAmount: number;
  last4: string;
}

export interface IPatientInfo {
  patientName: string;
  patientId: string;
}

export interface ICurrentPlanInfo {
  planId: string;
  planName: string;
  enrollmentStatus?: EnrollmentStatus;
  enrollmentId?: string;
  subscriptionStatus?: CareSubscriptionPaymentStatus | null;
  careStripeSubscriptionId: string;
}

export interface INewPlanInfo {
  planId: string;
  planName: string;
}

export interface ITransferPet {
  transferPetId?: string;
  transferPetName?: string;
}

export enum PaymentMethod {
  CardOnFile = 'Card on File',
  SendInvoiceLink = 'Send Invoice Link',
}

export interface IManageMembershipRequestInfo {
  clinic: IClinicInfo;
  clinicUser: IUserInfo;
  pointOfContact: IUserInfo;
  client: IClientInfo;
  stripeCustomer: IStripeCustomerInfo;
  trueUpInfo: ITrueUpInfo;
  patient: IPatientInfo;
  currentPlan: ICurrentPlanInfo;
  requestType: ManageMembershipRequestType;
  newPlan?: INewPlanInfo;
  cancelReason?: CancelReasonType;
  transferPet?: ITransferPet;
  inputFieldText: string;
  paymentMethod?: PaymentMethod;
  paymentSchedule?: PaymentSchedule;
}

export enum RefundOptions {
  Refund = 'Refund',
  NoRefund = 'NoRefund',
}

export interface IFormValues {
  pointOfContactId: string;
  requestType: ManageMembershipRequestType;
  cancelReason?: CancelReasonType;
  trueUpAmount?: number;
  transferPetId?: string;
  upgradePlanId?: string;
  paymentSchedule?: PaymentSchedule;
  paymentMethod?: PaymentMethod;
  allowRefund?: RefundOptions;
}

export interface PaymentsMade {
  quantity: number;
  price: number;
  total: number;
}
